import React, { Fragment, Component } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

import VolumeControl from "../Components/VolumeControl";
import Header from "../Components/Header";
import Button, { icons } from "../Components/Button";
import Menu from "../Components/Menu";
import Artists from "../Components/Artists";
import ShareSong, { mailtoString } from "../Components/ShareSong";
import { API_URL } from '../Config';

const DEFAULT_TRACK = {
  track: {
    name: 'Loading',
    artists: [{ name: '...connecting' }],
    album: {
      colors: {
        primary: 'grey'
      }
    }
  },
  playFrom: {
    name: '...Loading'
  }
}

const PlayPauseWrapper = styled.div`
  position: relative;
  height: 34px;
  width: 34px;
  margin: 0 4rem;
  perspective: 800px;
`

const PlayPauseButton = styled(Button)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  transition:  transform .2s ease-in-out;
  color: #000;
  ${({ visible }) => visible && `transform: rotate3d(1, 0, 0, 0deg) scale(1);`}
  ${({ visible }) => !visible && `transform: rotate3d(1, 0, 0, -90deg) scale(.9);`}
`

const PauseButton = PlayPauseButton.extend`
  transition-delay: ${({ visible }) => visible ? '.2s' : '0s'};
  flex: 1;
  width: 100%;
  height: 100%;
`;
const PlayButton = PlayPauseButton.extend`
  transition-delay: ${({ visible }) => visible ? '.2s' : '0s'};
  flex: 1;
  width: 100%;
  height: 100%;
`;

const PlayerWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const CurrentTrack = styled.div`
  flex: 1;  
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  position: relative;

  > div {
    position: relative;
    width: calc(100vh - 350px);
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`

const AlbumImage = styled.div`
  display: flex;
  justify-content: center;

  img {
    flex: 1;
    object-fit: contain;
    display: block;
  }
`;

const TrackInfo = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;

  > * {
    transition:  transform .15s ease-in-out;
    transition-delay: ${({ visible }) => visible ? '.15s' : '0s'};
    ${({ visible }) => !visible && `
    transform: rotateX(90deg);
  `}
`;

const StatusInfo = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  
  > * {
    transition:  transform .15s ease-in-out;
    transition-delay: ${({ visible }) => visible ? '.15s' : '0s'};
    ${({ visible }) => !visible && `
    transform: rotateX(90deg);
  `}
  } 
`;

const MusicNotes = styled.span`
  width: 15px;
  height: 15px;
  display: inline-block;
  position: relative;
  top: 4px;
  margin-right: 6px;

  svg {
    width: 100%;
    height: 100%;
  }
`

const PlayerControl = styled(Button)`
transition: color .25s ease-in-out;
  ${({ disabled }) => disabled && `color: #ccc;`}
`

export default class Player extends Component {
  constructor(props) {
    super(props);

    this.state = {
      displayMode: false,
      currentZone: null,
      statusTitle: 'Paused',
      statusDescription: 'Press play to start music',
      showStatusInfo: false,
    };
  }

  patchRequest = action => {
    const updateTime = new Date()
    this.lastUpdate = updateTime
    fetch(`${API_URL}/zone?token=${this.props.currentZone.token}`, {
      method: "PATCH",
      body: JSON.stringify(action)
    })
      .then(response => response.json())
      .catch(error => console.error("Error", error))
      .then(response => {
        console.log('patch response', response);
        setTimeout(() => { if (this.lastUpdate === updateTime) this.props.setCurrentZone() }, 3000);
      });
  };


  componentWillMount = () => {
    this.checkForInactivity();
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps) return;
    this.lastUpdate = new Date()
    if (this.state.showStatusInfo && nextProps.playback.state === 'playing') {
      this.setState({ showStatusInfo: false });
    }
    if (this.props.playback !== nextProps.playback) {
      this.setState({ showStatusInfo: false });
    }
    if (nextProps.playback.state === 'paused') {
      this.setState({ showStatusInfo: true, statusTitle: 'Paused', statusDescription: 'Press play to start music' });
    }
  }

  componentWillUnmount() {
    window.clearTimeout(this.inactiveTimeout);
    window.removeEventListener('mousemove', this.checkForInactivity);
  }

  removeZone = () => {
    if (window.confirm("Are you sure you want to remove this player?")) {
      const player = this.props.currentZone;
      const locations = window.persistence.local.get("locations") || {};
      Object.keys(locations).forEach(location => {
        const playerIndex = locations[location].zones.findIndex(
          zone => zone.remoteCode === player.remoteCode
        );
        if (locations[location].zones.length < 2) {
          delete locations[location];
        } else {
          locations[location].zones.splice(playerIndex, 1);
        }
      });
      window.persistence.local.set("locations", locations);
      this.props.history.push("/");
    }
  }

  checkForInactivity = e => {
    if (!this.listenerActive) {
      this.listenerActive = true;
      window.addEventListener('mousemove', this.checkForInactivity);
    }

    this.inactiveTimeout && window.clearTimeout(this.inactiveTimeout);
    this.inactiveTimeout = setTimeout(() => {
      this.listenerActive = false;
      window.removeEventListener('mousemove', this.checkForInactivity);
      this.setState({ displayMode: true })
    }, 30000);
  }

  handleEscapeKey = e => {
    if (e.key === "Escape") {
      window.removeEventListener("keydown", this.handleEscapeKey);
      this.setState({ displayMode: false });
    }
  };

  handleDisplayModeMenuOption = () => {
    this.setState({ displayMode: true });
    window.addEventListener("keydown", this.handleEscapeKey);
  }

  handleImageClick = () => {
    this.setState({ displayMode: true });
  };

  render() {
    if (!this.props.currentTrack) {
      return <div />;
    }

    const {
      currentZone,
      currentTrack,
      playback,
      upcoming
    } = this.props;

    const nowPlaying = currentTrack.track.id ? currentTrack : DEFAULT_TRACK;
    return (
      <Fragment>
        {this.state.displayMode && playback.state !== 'paused' ? (
          <div
            onClick={() => {
              this.setState({ displayMode: false })
              this.checkForInactivity();
            }}
            // onMouseMove={() => {
            //   this.setState({ displayMode: false })
            //   this.checkForInactivity();
            // }}
            style={{
              backgroundColor: nowPlaying.track.album.colors.primary,
              height: "100vh",
              padding: '2rem',
              display: 'flex',
              justifyContent: 'space-between'
            }}
          >
            <div style={{ color: '#FFF', marginRight: '1rem', width: '33%' }}>
              <span>Now playing</span>
              <h1 style={{ marginTop: '1rem', marginBottom: '.25rem' }}>{nowPlaying.track.name}</h1>
              <h2 className="book">
                <Artists artists={nowPlaying.track.artists} />
              </h2>
            </div>
            <AlbumImage style={{ display: 'flex', flex: 1 }}>
              {nowPlaying.track.album.image ?
                <img style={{ width: '100%', objectPosition: 'right top' }} src={nowPlaying.track.album.image.url} alt="current album" />
                :
                <div style={{ height: '650px', width: '650px', backgroundColor: 'lightgrey', objectFit: 'contain', objectPosition: 'center' }}></div>
              }
            </AlbumImage>
          </div>
        ) : (
            <Fragment>
              <Header
                title={currentZone.name}
                subTitle={currentZone.location.name}
                backPath="/"
                rightComponent={
                  <Menu
                    label='Settings'
                    options={[
                      { label: 'Help', onClick: () => window.open('https://help.soundtrackbusiness.com/', '_blank') },
                      { label: 'Remove Player', onClick: this.removeZone }
                    ]} />
                }
              />
              <PlayerWrapper>
                <CurrentTrack>
                  <div>
                    <div
                      onClick={this.handleImageClick}
                      style={{ paddingBottom: '100%', position: 'relative' }}
                    >
                      {nowPlaying.track.album.image ?
                        <img style={{ width: '100%', position: 'absolute' }} src={nowPlaying.track.album.image.url} alt="current album" />
                        :
                        <div style={{ position: 'absolute', top: 0, bottom: 0, left: 0, right: 0, backgroundColor: '#0019F8' }}></div>
                      }
                    </div>
                    <div style={{ display: "flex", width: "100%", flexShrink: 0, maxWidth: '28rem', margin: '0 auto', alignItems: 'center', padding: '2rem 0', position: 'relative' }}>
                      <div style={{ width: '1rem' }}>
                      </div>
                      <div style={{ flexGrow: 1 }}>
                        <TrackInfo visible={!this.state.showStatusInfo}>
                          <h3 style={{ margin: '0', marginBottom: '.5rem', fontWeight: '300', fontSize: '1.1rem' }}>{nowPlaying.track.name}</h3>
                          <div><Artists artists={nowPlaying.track.artists} /></div>
                        </TrackInfo>

                        <StatusInfo visible={this.state.showStatusInfo}>
                          <h3 style={{ margin: '0', marginBottom: '.5rem', fontWeight: '300', fontSize: '1.1rem' }}>{this.state.statusTitle}</h3>
                          <div>{this.state.statusDescription}</div>
                        </StatusInfo>
                      </div>
                      <div style={{ width: '1rem' }}>
                        <Menu
                          icon={icons.playerMenu}
                          options={[
                            { label: 'Display Mode', onClick: this.handleDisplayModeMenuOption },
                            { label: 'Share Song', onClick: () => window.location.href = mailtoString(this.props.currentTrack.track.name, this.props.currentTrack.track.artists[0].name, this.props.currentTrack.track.shareUrl) },
                            { label: 'Recently Played', to: '/recent' },
                            { label: 'Change Music', to: '/change-music' }
                          ]}
                        />
                        {/* <Select
                            style={{ width: "auto", position: 'absolute', right: 0 }}
                            defaultValue="default"
                            name="settings"
                            id="settings"
                            onChange={e => this.handlePlayerMenuChange(e.target.value)}
                          >
                            <option value="default" disabled>
                              menu
                          </option>
                            <option value="displayMode">Display Mode</option>
                            <option value="share">Share Song</option>
                            <option value="recent">Recently Played</option>
                            <option value="change-music">Change Music</option>
                          </Select> */}
                      </div>
                    </div>
                  </div>
                </CurrentTrack>
                <div style={{ display: "flex", alignItems: 'center', margin: '1rem 0' }}>
                  <ShareSong song={nowPlaying.track} icon={icons.share} disabled={playback.state === 'paused'} />
                  <PlayPauseWrapper>
                    <PlayButton
                      label="play"
                      icon="play"
                      visible={playback.state !== 'playing'}
                      onClick={() => {
                        this.patchRequest({ action: "play" })
                        this.setState({ statusTitle: 'Paused', statusDescription: 'Press play to start music', showStatusInfo: true })
                      }}
                    />
                    <PauseButton
                      label="pause"
                      icon="pause"
                      visible={playback.state === 'playing'}
                      onClick={() => {
                        this.patchRequest({ action: "pause" })
                      }}
                    />
                  </PlayPauseWrapper>
                  <PlayerControl
                    onClick={() => {
                      this.setState({ statusTitle: 'Changing Track...', statusDescription: '', showStatusInfo: true })
                      this.patchRequest({ action: "skipTrack" })
                    }
                    }
                    label='next'
                    icon='skip'
                    disabled={playback.state === 'paused'}
                  />
                </div>
                <VolumeControl
                  defaultValue={playback.volume}
                  currentVolume={this.state.currentVolume !== undefined ? this.state.currentVolume : playback.volume}
                  onChange={(el) => {
                    const volumeChange = parseInt(el.target.value, 10)
                    this.setState({ currentVolume: volumeChange, statusTitle: volumeChange, statusDescription: 'Release to set volume', showStatusInfo: true })
                  }}
                  handleTouchEnd={
                    el => {
                      const volumeChange = parseInt(el.target.value, 10)
                      if (volumeChange !== playback.volume) {
                        this.patchRequest({
                          action: "setVolume",
                          volume: volumeChange
                        })
                        this.setState({ statusTitle: volumeChange, statusDescription: 'Setting volume...', showStatusInfo: true })
                      } else if (this.state.showStatusInfo) {
                        this.setState({ showStatusInfo: false })
                      }
                    }
                    // change player text back to song and artist name
                  }
                />
              </PlayerWrapper>
              <div style={{ display: "flex", justifyContent: "center", padding: '1rem' }}>
                <Link to="/change-music">
                  {/* check if playfrom is equal show if not show 'upcoming' and show upcoming playlist */}
                  {upcoming && upcoming.name !== nowPlaying.playFrom.name && <span>Upcoming: </span>}
                  <MusicNotes>{icons.musicNotes}</MusicNotes>
                  <span>{upcoming && upcoming.name !== nowPlaying.playFrom.name ? upcoming.name : nowPlaying.playFrom.name}</span>
                </Link>
              </div>
            </Fragment>
          )}
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Views/Player.js